/**
 * Application configuration
 * Centralized configuration management
 */

export const config = {
  // API Configuration
  // In development, use relative path to leverage Vite proxy (for cookies)
  // In production, use VITE_API_BASE_URL (must be set at build time)
  apiBaseURL: import.meta.env.DEV 
    ? '/api' 
    : import.meta.env.VITE_API_BASE_URL,
  
  // Socket.IO Configuration - REQUIRED
  socketURL: import.meta.env.VITE_SOCKET_URL,
  
  // Google Maps API Key - REQUIRED
  googleMapsAPIKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  
  // OSRM Routing - REQUIRED
  osrmURL: import.meta.env.VITE_OSRM_URL,
  
  // IdYangu URL - REQUIRED
  idyanguURL: import.meta.env.VITE_IDYANGU_URL,
  
  // Firebase / FCM (optional - for push notifications)
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
  } as const,
  get isFCMConfigured(): boolean {
    const f = this.firebase
    return !!(f.apiKey && f.projectId && f.vapidKey && f.messagingSenderId)
  },
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // App Info
  appName: 'School Bus Tracker',
} as const

export { buildInfo, formatBuildLabel } from './buildInfo'

export default config
